// extracted by mini-css-extract-plugin
module.exports = {"benefits__item":"styles_benefits__item__5oXCM"};